// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".spinner-cover{align-items:center;align-items:flex-start;display:flex;height:100%;justify-content:center;left:0;position:absolute;top:0;width:100%;z-index:1051}.spinner-backdrop{backdrop-filter:blur(10px);background:hsla(0,0%,100%,.5)}.spinner-progress{height:4px;max-width:80vw;width:200px}.spinner-progress .progress-bar{transition:width .6s ease}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
